import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { ContractsService } from '@api/contracts.service';
import { contractsRequestData } from '@shared/model/contracts.model';
import jalaliMoment = require('jalali-moment');
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-contracts',
  templateUrl: './contracts.component.html',
  styleUrls: ['./contracts.component.scss']
})
export class ContractsComponent implements OnInit {
  revisionList
  startPage = 1;
  pageSize = 100;
  totalPage = 0;
  public destroy$ = new Subject<void>();
  contractsRequest: contractsRequestData;

  constructor( private contractService: ContractsService ) { }

  ngOnInit(): void {
    this.contractService.getContracts(this.pageSize ,this.startPage ).pipe(takeUntil(this.destroy$ )).subscribe(
      (res) => {
        this.contractsRequest = res;
        this.contractsRequest.resList.forEach((element): any => {
          element.createdDate = jalaliMoment( element.createdDate).format('jYYYY/jMM/jDD hh:mm');
        });
        this.totalPage = Math.ceil(res.total / this.pageSize);
      }
    )
  }
    public getServerData(event?: PageEvent){
      this.pageSize = event.pageSize
      this.contractService.getContracts(this.pageSize ,(event.pageIndex) + 1 ).pipe(takeUntil(this.destroy$ )).subscribe(
        (res) => {
          this.contractsRequest = res;
    }
      )}
}
